import React from "react";
import { FieldGroup } from "../FieldGroup/FieldGroup";
import {
  FieldLabel,
  FieldWrapper,
} from "../../sections/DynamicForm/DynamicForm.styles";
import { FormSpanError } from "../FormBuilder/FormBuilder.styles";
import { FormElement } from "../../sections/DynamicForm/DynamicForm.types";

interface RadioGroupProps {
  element: FormElement;
  commonProps: any;
  formStyles: any;
  handleFieldChange: (fieldName: string) => void;
}

export const RadioGroup: React.FC<RadioGroupProps> = ({
  element,
  commonProps,
  formStyles,
  handleFieldChange,
}) => {
  const { props } = element;
  const { label, attribute_name, options, validation } = props;
  const fieldName = attribute_name;

  return (
    <FieldGroup
      key={commonProps.id}
      title={label}
      colorTitle={formStyles?.textColor}
    >
      <FieldWrapper>
        {options?.map((option: { value: string; label: string }) => (
          <FieldLabel key={option.value} color={formStyles?.textColor}>
            <input
              type="radio"
              name={attribute_name}
              value={option.value}
              required={validation?.required}
              onChange={() => fieldName && handleFieldChange(fieldName)}
            />
            {option.label}
          </FieldLabel>
        ))}
      </FieldWrapper>
      {commonProps.error && <FormSpanError>{commonProps.helperText}</FormSpanError>}
    </FieldGroup>
  );
};
